import { AxiosError, AxiosResponse } from 'axios';
import { apiService } from '@services/apiService';
import { types, flow } from 'mobx-state-tree';
import { saveToken, removeToken } from '@utils/tokenUtils';
import { ErrorData, IResponse } from '@/types/common';
import { withAlertStore } from '../alert/withAlertStore';
import { withProfileStore } from '../profile/withProfileStore';
import { withMainStore } from '../main/withMainStore';
import { IAuthData, ISocAuthReq, IUserProfileData, IVerifyCodeReq, AuthStepType } from './types';

const { model, maybeNull, frozen, string } = types;

export const AuthStore = model('AuthStore', {
  authData: maybeNull(frozen<IAuthData>()),
  authStep: frozen<AuthStepType>(),
  token: maybeNull(string),
})
  .extend(withAlertStore)
  .extend(withProfileStore)
  .extend(withMainStore)
  // .views((self) => ({}))
  .actions((self) => ({
    setAuthData(data: IAuthData) {
      self.authData = data;
    },
    setAuthStep(step: AuthStepType) {
      self.authStep = step;
    },
    normalizeProfile({ user, accessToken }: IUserProfileData) {
      self.profileStore.setUser(user);
      if (user.isAgreedPolicy) saveToken(accessToken);
      else self.token = accessToken;
      return user;
    },
    setToken(token: string | null) {
      self.token = token;
    },
    removeProfile(): void {
      self.profileStore.setUser(null);
      self.mainStore.setSelectedCountryCode(null);
      removeToken();
    },
  }))
  .actions((self) => ({
    sendCreds: flow(function* (data: IAuthData) {
      self.setAuthData(data);
      const res = yield apiService.post(`auth/code`, data).catch(self.mainStore.errorHandling);
    }),
    verifyCode: flow(function* (code: string) {
      if (!self.authData) return;
      const data: IVerifyCodeReq = {
        email: self.authData.email,
        code,
      };
      return yield apiService
        .post(`auth/login`, data)
        .then(({ data: { data } }) => self.normalizeProfile(data))
        .catch(self.mainStore.errorHandling);
    }),
    loginWithSoc: flow(function* (data: ISocAuthReq) {
      return yield apiService
        .post(`auth/social-auth`, data)
        .then(({ data: { data: userData } }) => {
          return self.normalizeProfile(userData);
        })
        .catch(self.mainStore.errorHandling);
    }),
    logout: flow(function* () {
      yield apiService
        .post('profile/logout', {})
        .then(self.removeProfile)
        .catch(self.mainStore.errorHandling);
    }),
  }));
